export const required = value => (!value || value === false);
export const maxLength = max => value => value && value.length > max;
export const minLength = min => value => value && value.length < min;
export const number = value => value && isNaN(Number(value));
export const minValue = min => value => value && value < min;
export const greaterThan0 = minValue(1);
export const email = value =>
    value && !/^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'Invalid email address'
        : undefined;
export const alphaNumeric = value =>
    value && /[^a-zA-Z0-9 ]/i.test(value)
        ? 'Only alphanumeric characters'
        : undefined;
export const phoneNumber = value =>
    value && !/^(0|[1-9][0-9]{9})$/i.test(value)
        ? 'Invalid phone number, must be 10 digits'
        : undefined;


// WEBPACK FOOTER //
// ./src/lib/FormValidators.js